let Form = require('./form');

module.exports = Form;



// WEBPACK FOOTER //
// ./node_modules/tortilla/src/form/index.js